<template>
    <v-container fluid>
        <InfoAlert :showDismissibleAlert="showDismissibleAlert" v-on:close="showDismissibleAlert = false" :info="info" />
        <!-- <v-row>
            <v-col>
                <ChecklistStatusStats />
            </v-col>
        </v-row> -->
        <v-row>
            <v-col>
                <ManufacturingLogbookCountStats />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <ManufacturingLogbookTimeStats />
            </v-col>
        </v-row>
        <!-- <v-row>
            <v-col>
                <ChecklistSubmissionStats />
            </v-col>
        </v-row> -->
    </v-container>
</template>

<script>
import InfoAlert from '@/components/InfoAlert.vue';
// import axios from 'axios';
// import moment from 'moment';
// import ChecklistSubmissionStats from '@/components/panels/manufacturing/checklists/ChecklistSubmissionStats.vue';
// import ChecklistStatusStats from '@/components/panels/manufacturing/checklists/ChecklistStatusStats.vue';
import ManufacturingLogbookTimeStats from '@/components/panels/manufacturing/logbooks/summary/ManufacturingLogbookTimeStats.vue';
import ManufacturingLogbookCountStats from '@/components/panels/manufacturing/logbooks/summary/ManufacturingLogbookCountStats.vue';
export default {
    name: 'ManufacturingLogbookSummary',
    components: {
        InfoAlert,
        // ChecklistSubmissionStats,
        // ChecklistStatusStats,
        ManufacturingLogbookTimeStats,
        ManufacturingLogbookCountStats,
    },
    data(){
        return {
            loading:false,
            showDismissibleAlert:false,
            info:''
        }
    }



}
</script>